export const MAX_STATUS_IDS_PER_REQUEST = 200;
export const STATUS_POLL_BACKOFF_CEILING_MS = 30_000;
export const STATUS_POLL_JITTER_MS = 500;
export const MISSING_STATUS_REASON =
  'Status was not returned by the backend. Refresh status to try again.';
